<app-shared-workshop-card
  [title]="workshop.title"
  [coverImage]="workshop.coverImage"
  [description]="workshop.description"
  [rows]="cardRows"
  [actions]="cardActions"
></app-shared-workshop-card>

<dx-popup
  deferRendering="true"
  contentTemplate="content"
  height="auto"
  width="auto"
  hideOnOutsideClick="true"
  rtlEnabled="true"
  [(visible)]="showApprovalPromptPopup"
>
  <div *dxTemplate="let data of 'content'">
    <app-registration-approval-prompt [template]="approvalTemplate">
    </app-registration-approval-prompt>
    <ng-template #approvalTemplate let-data>
      فراگیر گرامی! مجوز مشاهده ویدیو کارگاه های آموزشی افرا برای شما صادر نشده
      است. برای دریافت مجوز مربوطه با مدیر عامل موسسه نیکوکاری خود
      {{ data.charityTitle }} سرکار خانم/جناب آقای
      <strong>{{ data.ceoFullName }}</strong> تماس بگیرید.
    </ng-template>
  </div>
</dx-popup>
